// extracted by mini-css-extract-plugin
export default {"cabecalho":"FiltroDataCabecalho_cabecalho__iZ+3Z"};